import React, { useMemo, useState } from 'react';
import { list, prize } from '../../../public/json/entry.json';
import * as Navi from 'navi';
import { EntriesRepository } from '../../repositories/entries';
import ProfileApp from '../ProfileApp';
import { Prize } from '../../../../components/src/components';

// NOTE:- Profileを表示するのは、二次審査以降の通過者のみ
let profiles = list
  .filter((entry: any) => prize[Prize.second].includes(entry.id))
  .map(entry => ({
    id: entry.id,
    getPage: Navi.map(async () => {
      const profile = await EntriesRepository.getProfile(entry.id);
      const prize = await EntriesRepository.getMaxPrize(entry.id);
      return Navi.route({
        title: `${entry.name} | ${process.env.REACT_APP_WEBSITE_NAME}`,
        getView: () => {
          return <ProfileApp entry={entry} profile={profile || {}} prize={prize} />;
        },
      });
    }),
  }));

export default profiles;
